module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.8ced95a0.eot";